<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<router-outlet>
  <app-spinner></app-spinner>
  <app-cancel-order-submission></app-cancel-order-submission>
</router-outlet>
